


















import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class Scanner extends Vue {
  @Prop({ default: false}) public mobile!: boolean;
  @Prop({ default:  360 }) public minWidth!: number;
  @Prop({ default: 680 }) public width!: number;
  @Prop({ default: 1920 }) public maxWidth!: number;
  @Prop({ default: 240 }) public minHeight!: number;
  @Prop({ default: 480 }) public height!: number;
  @Prop({ default: 1080 }) public maxHeight!: number;
  @Prop({ default: false }) public paused!: boolean;

  public cameraLoading = false;
  public useRearCamera = true;
  public errorMessage = '';

  @Watch('errorMessage')
  public onErrorChange(val: string) {
    this.$emit('onError', val);
  }

  public onDecode(decodedString: string) {
    const slice =  decodedString.split('/').slice(1);
    const address = slice[2];
    this.$emit('decode', address);

  }

  public async onInit(promise: Promise<any>) {
    // show loading indicator
    this.$emit('cameraLoading', true);
    this.cameraLoading = true;

    try {
      await promise;
      // successfully initialized
    } catch (error) {
      if (error.name === 'NotAllowedError') {
        // user denied camera access permisson
        this.errorMessage = 'Hey! I need access to your camera';
      } else if (error.name === 'NotFoundError') {
        // no suitable camera device installed
        this.errorMessage = 'Do you even have a camera on your device?';
        this.$emit('no-camera');
      } else if (error.name === 'NotSupportedError') {
        // page is not served over HTTPS (or localhost)
        this.errorMessage = 'Seems like this page is served in non-secure context (HTTPS, localhost or file://)';
      } else if (error.name === 'NotReadableError') {
        // maybe camera is already in use
        this.errorMessage = 'Couldn\'t access your camera. Is it already in use?';
      } else if (error.name === 'OverconstrainedError') {
        // passed constraints don't match any camera.
        // Did you requested the front camera although there is none?
        this.errorMessage =
          'Constraints don\'t match any installed camera. Did you asked for the front camera although there is none?';
      } else {
        // browser might be lacking features (WebRTC, ...)
        this.errorMessage = 'UNKNOWN ERROR: ' + error.message;
        this.$emit('no-camera');
      }
    } finally {
      // hide loading indicator
      this.$emit('cameraLoading', false);
      this.cameraLoading = false;
    }
  }


  public switchCamera() {
    this.useRearCamera = !this.useRearCamera;
  }
}
